import {NgModule} from '@angular/core';
import {CoreContainerComponent} from '@appComponents/core-container/core-container.component';
import {
  AlertSuccessModule,
  PopUpAlertModule,
} from '@ryndem/pq2-design-system-legacy/alerts-components';
import {UploadViewFileModule} from '@ryndem/pq2-design-system-legacy/forms-components';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NavBarComponent} from '@appComponents/core-container/nav-bar/nav-bar.component';
import {HeaderComponent} from '@appComponents/core-container/header/header.component';
import {FooterComponent} from '@appComponents/core-container/footer/footer.component';
import {TranslateModule} from '@ngx-translate/core';
import {StoreModule} from '@ngrx/store';
import {DIALOGS_FEATURE_KEY} from '@appUtil/common.protocols';
import {dialgosReducer} from '@appReducers/dialogs/dialogs.reducer';
import {CustomPositionPopUpNotesModule} from '@appComponents/shared/custom-position-pop-up-notes/custom-position-pop-up-notes.module';
import {PqfDraggableModalModule, PqfGeneralLoadingModule} from '@ryndem/pq2-design-system-classic';
import {EffectsModule} from '@ngrx/effects';
import {PendingsCounterEffects} from '@appEffects/pendings/signalR/pendingsCounter.effects';
import {TranslocoModule} from '@ngneat/transloco';

@NgModule({
  imports: [
    PopUpAlertModule,
    CommonModule,
    AlertSuccessModule,
    RouterModule,
    TranslateModule,
    UploadViewFileModule,
    PqfGeneralLoadingModule,
    StoreModule.forFeature(DIALOGS_FEATURE_KEY, dialgosReducer),
    CustomPositionPopUpNotesModule,
    PqfDraggableModalModule,
    EffectsModule.forFeature([PendingsCounterEffects]),
    TranslocoModule,
  ],
  exports: [CoreContainerComponent, HeaderComponent],
  declarations: [CoreContainerComponent, NavBarComponent, HeaderComponent, FooterComponent],
})
export class CoreContainerModule {}
